import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';

import createRootReducer from '../reducers';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

const defaultDataStore = store => next => action => {
  const { type } = action;
  if (process.env.NODE_ENV === 'development') {
    console.log('Action: ', type);
    console.log('Store: ', store.getState());
  }
  if (type.includes('AUTHENTICATIONS_LOGOUT')) {
    Object.keys(store.getState()).forEach(key => {
      const keys = Object.keys(store.getState()[key]);
      if (keys.includes('data')) {
        store.getState()[key].data = [];
      }
    });
    store.getState().dashboards.enableTransition = false;
    next(action);
    return store.getState();
  } else {
    next(action);
    return store.getState();
  }
};

const configureStore = preloadedState => {
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    compose(applyMiddleware(routerMiddleware(history), thunk, defaultDataStore))
  );
  return store;
};

const store = configureStore();

export default store;
